import {
  chartOverlaysBorder,
  chartOverlaysBorder__rightAxis,
  chartOverlaysBorder__topAxis,
  chartOverlaysBorder__topSeparator,
  chartOverlaysBorder__xAxis,
  chartOverlaysBorder__yAxis,
} from './ChartOverlaysBorder.sty.js';

interface ChartOverlaysBorderProps {
  left?: boolean;
  right?: boolean;
  bottom?: boolean;
  top?: boolean;
  /** Draws a lighter top border acting as a separator rather than an axis line. */
  topSeparator?: boolean;
}

const chartOverlaysBorderStyle = (
  left: boolean = false,
  right: boolean = false,
  bottom: boolean = false,
  top: boolean = false,
  topSeparator: boolean = false,
): string => {
  return `
    ${chartOverlaysBorder}
    ${left ? chartOverlaysBorder__xAxis : ''}
    ${right ? chartOverlaysBorder__rightAxis : ''}
    ${bottom ? chartOverlaysBorder__yAxis : ''}
    ${top ? chartOverlaysBorder__topAxis : ''}
    ${topSeparator ? chartOverlaysBorder__topSeparator : ''}
  `;
};

/**
 * A component to render a mimic axis borders conditionally
 **/
export const ChartOverlaysBorder = ({
  left,
  right,
  bottom,
  top,
  topSeparator,
}: ChartOverlaysBorderProps) => {
  const style = chartOverlaysBorderStyle(
    left,
    right,
    bottom,
    top,
    topSeparator,
  );
  return <div className={style} />;
};
